import React from 'react'
import {ErrorMessage, Field} from 'formik'

interface Props {
  containerClassName?: string
  label?: string
  name: any
  validate?: any
  type?: any
  placeholder?: any
  onChange: any
  className?: any
  errors: any
  touched: any
  labelClassName?: string
  required?: boolean
  disabled?: boolean
  value?: string | number
  as?: string
  min?: string
  rows?: number
  avoidKey?: any
  onKeyUp?: any
  mainClassName?: string
  defaultValue?: number | string
  id?: string
}

const FormTextBox = React.memo((props: Props) => {
  const {
    containerClassName,
    label,
    name,
    type,
    className,
    errors,
    touched,
    labelClassName,
    required,
    onKeyUp,
    avoidKey,
    value,
    as,
    min,
    rows,
    defaultValue,
    mainClassName,
    id,
    ...rest
  } = props

  const fieldId = id ?? name
  const errorId = `${fieldId}-error`

  return (
    <div className={label ? 'row mb-6' : mainClassName || 'col-lg-6 '}>
      {label && (
        <label htmlFor={fieldId} className={`mb-1 fw-bolder fs-6 ${labelClassName || 'col-lg-4'}`}>
          <span className={required ? 'required' : ''}>{label}</span>
        </label>
      )}

      <div className={containerClassName ?? 'col-lg-6 '}>
        <Field
          id={fieldId}
          name={name}
          label={label}
          type={type || 'text'}
          className={className || 'form-control border'}
          autoComplete='off'
          as={as || 'input'}
          min={min}
          rows={as === 'textarea' ? rows : undefined}
          onKeyUp={onKeyUp}
          defaultValue={defaultValue}
          aria-required={required ? 'true' : undefined}
          aria-describedby={errors[name] && touched[name] ? errorId : undefined}
          aria-invalid={errors[name] && touched[name] ? 'true' : undefined}
          {...(avoidKey && {avoidKey: avoidKey})}
          {...(value && {value: value})}
          {...rest}
          data-cy={`${name}-text-field`}
        />
        <div id={errorId} className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
          <ErrorMessage name={name} component='div' className='field-error-message' />
        </div>
      </div>
    </div>
  )
})

export default FormTextBox
